"use strict";Object.defineProperty(exports, "__esModule", {value: true});


var _5OZ7J4C2cjs = require('./5OZ7J4C2.cjs');


var _VRR6XSK3cjs = require('./VRR6XSK3.cjs');


var _6E4BBKC4cjs = require('./6E4BBKC4.cjs');


var _FH6HQ5JNcjs = require('./FH6HQ5JN.cjs');




var _PTOCUU2Dcjs = require('./PTOCUU2D.cjs');


var _3BSDKDKDcjs = require('./3BSDKDKD.cjs');

// src/menubar/menubar.tsx
var _jsxruntime = require('react/jsx-runtime');
var TagName = "div";
var useMenubar = _PTOCUU2Dcjs.createHook.call(void 0, 
  function useMenubar2({
    store: storeProp,
    composite = true,
    orientation: orientationProp,
    virtualFocus,
    focusLoop,
    rtl,
    ...props
  }) {
    const context = _5OZ7J4C2cjs.useMenubarProviderContext.call(void 0, );
    storeProp = storeProp || context;
    const store = _VRR6XSK3cjs.useMenubarStore.call(void 0, {
      store: storeProp,
      orientation: orientationProp,
      virtualFocus,
      focusLoop,
      rtl
    });
    const orientation = _FH6HQ5JNcjs.useStoreState.call(void 0, 
      store,
      (state) => !composite || state.orientation === "both" ? void 0 : state.orientation
    );
    props = _3BSDKDKDcjs.useWrapElement.call(void 0, 
      props,
      (element) => /* @__PURE__ */ _jsxruntime.jsx.call(void 0, _5OZ7J4C2cjs.MenubarScopedContextProvider, { value: store, children: element }),
      [store]
    );
    if (composite) {
      props = {
        role: "menubar",
        "aria-orientation": orientation,
        ...props
      };
    }
    props = _6E4BBKC4cjs.useComposite.call(void 0, { store, composite, ...props });
    return props;
  }
);
var Menubar = _PTOCUU2Dcjs.forwardRef.call(void 0, function Menubar2(props) {
  const htmlProps = useMenubar(props);
  return _PTOCUU2Dcjs.createElement.call(void 0, TagName, htmlProps);
});




exports.useMenubar = useMenubar; exports.Menubar = Menubar;
